/**
 * @author Ariel
 * @description 消息通知详情页面配置
 * @Date 2021/06/24
 */
import React from 'react'
import {component_tool} from '@/tool'
import './index.less'

const { WizTooltip } = component_tool;
let componentName = 'messageNoticeRecordDetail'

const columns = [
  {
    name: 'id',
    formItem: {type: 'hidden'}
  },
  {
    title: '通知方式',
    name: 'sendType',
    searchItem: {type: 'select'},
    tableItem: {},
    dict: [
      {code: 0, codeName: '站内通知'},
      {code: 1, codeName: '推送通知'},
      {code: 3, codeName: '短信通知'},
      {code: 4, codeName: '邮件通知'},
      // {code: 5, codeName: '企业微信'},
      {code: 6, codeName: '语音通话'},
    ]
  },
  {
    title: '接收人',
    name: 'fullName',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '账号',
    name: 'userName',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '邮箱',
    name: 'email',
    tableItem: {}
  },
  {
    title: '手机号',
    name: 'mobile',
    tableItem: {}
  },
  {
    title: '发送时间',
    name: 'pushTime',
    tableItem: {}
  },
  {
    title: '推送状态',
    name: 'sendStatus',
    searchItem: {type: 'select'},
    tableItem: {},
    dict: [
      {code: 0, codeName: '待推送'},
      {code: 1, codeName: '推送成功'},
      {code: 2, codeName: '推送失败'},
    ]
  },
  {
    title: '推送内容',
    name: 'pushContent',
    tableItem: {
      width: 200,
      render: (text, record) => {
        return <WizTooltip className='notice-record-detail' title={text}>
          <div className='notice-record-detail' >
            {text}
          </div>
        </WizTooltip >
      }
    }
  },
]

const templateConfig = (e) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          buttonSort: [],
          buttons: []
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "uniqueId",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: [],
        rowOperateView: []
      }
    }
  }
};

const apis = (bizId, bizType, sceneName = []) => {
  return {
    list: {
      path: `messageNoticeRecord/recordByPage`,
      payload: {
        key: `messageNoticeRecord@recordByPage`,
        apiParams: {bizId, bizType, sceneName}
      }
    },
  }
}

let reduxTemplateConfig = (args) => {
  let {bizId, bizType, sceneName} = args
  return {
    apis: apis(bizId, bizType, sceneName),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
